import Raven from 'raven-js';
import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequest } from 'utils/http';
import { FETCH_USER } from 'containers/User/constants';
import { fetchUser } from 'containers/User/model';
import { get } from 'lodash';
import { logOut } from 'containers/App/actions';
import {
  fetchUserError,
  fetchUserSuccess,
  fetchUserSuccessSegment,
} from 'containers/User/actions';

const setUserContext = (options) => Raven.setUserContext(options);

export function* fetchUserSaga() {
  // Select username from store
  try {
    const userDetails = yield call(httpRequest, fetchUser, {
      excludedStatuses: [500],
    });
    const currentTier = get(userDetails, 'perkMetadata.tier');

    const userDetailsWithEnterpriseAsElite = userDetails;

    if (currentTier) {
      const enterpriseAsEliteTier = {
        ...currentTier,
        name: currentTier.name.replace(/^.*enterprise.*$/gim, 'Elite'),
      };

      userDetailsWithEnterpriseAsElite.perkMetadata = {
        ...userDetails.perkMetadata,
        tier: enterpriseAsEliteTier,
      };
    }

    yield put(fetchUserSuccess(userDetailsWithEnterpriseAsElite));
    yield put(fetchUserSuccessSegment(userDetailsWithEnterpriseAsElite));
    yield call(setUserContext, {
      id: userDetails.id,
      email: userDetails.email,
      username: userDetails.username,
    });
  } catch (error) {
    yield put(logOut());
    yield put(fetchUserError(error));
  }
}

export default function* defaultSaga() {
  yield takeLatest(FETCH_USER, fetchUserSaga);
}
